"use client";

import React, { useState } from "react";
import { useRouter } from "next/navigation";

export default function ServiceCard({
  title,
  description,
  bullets = [],
  tags = [], // fallback from backend
  minHeight = 400,
  icon, // optional Font Awesome class e.g. "fa-solid fa-rocket"
  accent = "#F48428", // optional brand color
}) {
  // Use tags if bullets is empty (common when fetching from backend)
  const displayBullets = bullets.length > 0 ? bullets : tags;
  const router = useRouter();
  const [hovered, setHovered] = useState(false);

  const cardStyle = {
    background: "rgba(12,12,12,0.35)",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 12,
    padding: 16,
    minHeight,
    width: "100%",
    maxWidth: 420,
    margin: "0 auto",
    position: "relative",
    transition:
      "transform .25s ease, box-shadow .25s ease, border-color .25s ease",
    transform: hovered ? "translateY(-4px)" : "none",
    boxShadow: hovered ? "0 14px 34px rgba(0,0,0,0.45)" : "none",
    borderColor: hovered ? "rgba(245,131,39,0.45)" : "rgba(255,255,255,0.1)",
  };

  const topBarStyle = {
    height: 4,
    width: hovered ? "100%" : 64,
    background: accent,
    borderRadius: 8,
    transition: "width .3s ease",
  };

  const badgeStyle = {
    background: "rgba(255, 255, 255, 0.05)",
    color: "#ffffff",
    padding: "8px 16px",
    borderRadius: 9999,
    border: "1px solid rgba(245, 131, 39, 0.35)",
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
    fontWeight: 500,
    fontSize: "0.85rem",
    letterSpacing: ".01em",
    display: "inline-block",
    width: "fit-content",
    backdropFilter: "blur(4px)",
  };

  const iconWrapStyle = {
    display: icon ? "inline-flex" : "none",
    alignItems: "center",
    justifyContent: "center",
    width: 72,
    height: 52,
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.15)",
    borderRadius: 12,
    boxShadow: "0 8px 18px rgba(0,0,0,0.22)",
  };

  const btnStyle = {
    right: 16,
    bottom: 16,
    width: 56,
    height: 56,
    borderRadius: "50%",
    border: "2px solid rgba(255,255,255,0.35)",
    background: "rgba(0,0,0,0)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    position: "absolute",
  };

  return (
    <div
      className="rounded-4 h-100 p-4 position-relative"
      style={cardStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={topBarStyle}></div>
      {icon && (
        <div className="mt-3" aria-hidden>
          <div style={iconWrapStyle}>
            <i className={icon} style={{ color: accent, fontSize: 26 }}></i>
          </div>
        </div>
      )}
      <h5 className="fw-bold mt-3 text-white">{title}</h5>
      <p className="mb-3" style={{ color: "rgba(255, 255, 255, 0.65)", fontSize: "0.95rem", lineHeight: "1.6" }}>
        {description}
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {displayBullets.map((t) => (
          <span key={t} className="badge rounded-pill" style={badgeStyle}>
            {t}
          </span>
        ))}
      </div>
      <button
        type="button"
        aria-label="Contact us"
        className="position-absolute"
        style={btnStyle}
        onClick={() => router.push("/contact")}
      >
        <i className="fa-solid fa-arrow-right" style={{ fontSize: 20 }}></i>
      </button>
    </div>
  );
}
